import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { COMMON_APP_CONFIG } from '../tokens/common-config.token';

/** Un articolo come lo mostra la dashboard: solo quello che serve in elenco. */
export interface ArticoloRecente {
  id: number;
  titolo: string;
  permalink: string;
  approvato: string;
  data: number;
  updatedAt: string;
  categoria: { id: number; nome: string } | null;
  autore: { id: number; blogger: string } | null;
}

export interface StatisticheRedazione {
  bozze: number;
  programmati: number;
  pubblicatiOggi: number;
  /** Arrivati dal modulo pubblico e ancora da revisionare. */
  daRevisionare: number;
  ultimi: ArticoloRecente[];
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly http = inject(HttpClient);
  private readonly base: string;

  constructor(@Inject(COMMON_APP_CONFIG) mainConfig: Required<{ api: { apiBaseUrl: string } }>) {
    this.base = mainConfig.api.apiBaseUrl + 'gestione-articoli/articoli/';
  }

  statistiche(): Observable<StatisticheRedazione> {
    return this.http.get<StatisticheRedazione>(`${this.base}statistiche`, {
      responseType: 'json',
      withCredentials: true,
    });
  }
}
